import i18n from 'i18n';
import { ColDef } from '@ag-grid-enterprise/all-modules';
import { AdaptedAfWhitelist } from 'data/afWhitelist/afWhitelist.types';

export enum AfWhitelistMenuActionsType {
  Delete = 'delete',
  Edit = 'edit',
  View = 'view'
}

export const newAfWhitelist: AdaptedAfWhitelist = {
    id: '',
    AFID: '',
    AFPROTOCOL: 'ANY',
    AFTYPE: '',
    GRAYITEM: false,
    IPADDR: '',
  };

export const afWhitelistColumnDefs: ColDef[] = [

  {
    headerName: i18n.t('afWhitelist.grid.afid'),
    field: 'AFID',
    flex: 2,
    filter: 'agTextColumnFilter',
    floatingFilter: true
  },
  {
    headerName: i18n.t('afWhitelist.grid.ipaddr'),
    field: 'IPADDR',
    flex: 2,
    filter: 'agTextColumnFilter',
    floatingFilter: true
  },
  {
    headerName: i18n.t('afWhitelist.grid.aftype'),
    field: 'AFTYPE',
    flex: 2,
    filter: 'agTextColumnFilter',
    floatingFilter: true
  },
  {
    headerName: i18n.t('afWhitelist.grid.afprotocol'),
    field: 'AFPROTOCOL',
    flex: 2,
    filter: 'agTextColumnFilter',
    floatingFilter: true
  },
  {
    headerName: i18n.t('afWhitelist.grid.greyitem'),
    field: 'GRAYITEM',
    flex: 2,
  },
];
